import { ReactNode } from "react"

import { Typography } from "@mui/material"

import { ErrorOutlineRoundedIcon, InfoOutlinedIcon, WarningAmberRoundedIcon } from "@l2r-front/l2r-icons"

import * as Styled from "./InfoFrame.styled"

type InfoFrameButtonProps = {
    className?: string
    children: ReactNode
    variant?: "info" | "warning" | "error" | "success"
}

export const InfoFrame = (props: InfoFrameButtonProps) => {

    const {
        className,
        children,
        variant = "info",
    } = props

    const variantConfig = {
        info: {
            icon: InfoOutlinedIcon,
            color: "info",
            textColor: "_components/alert/info/color",
        },
        warning: {
            icon: WarningAmberRoundedIcon,
            color: "warning",
            textColor: "_components/alert/warning/color",
        },
        error: {
            icon: ErrorOutlineRoundedIcon,
            color: "error",
            textColor: "_components/alert/error/color",
        },
        success: {
            icon: InfoOutlinedIcon,
            color: "success",
            textColor: "_components/alert/success/color",
        },
    }

    const Icon = variantConfig[variant].icon

    return (
        <Styled.Container color={variantConfig[variant].color} className={className}>
            <Icon fontSize="small" />
            <Typography variant="Desktop & Mobile/Body/Small" color={variantConfig[variant].textColor

            }>
                {children}
            </Typography>
        </Styled.Container>
    )
}
